/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { PCView, SPView } from "components/common/MediaQuery";
import { withNoTranslate } from "i18n/noTranslate";
import React from "react";
import { AspectRatioImage } from "ui/AspectRatioImage";

import type { FC } from "react";

type Props = {
  eventDateTime: string;
  eventThumbnailURL: string;
  eventTitle: string;
};

export const ResaleEventSummary: FC<Props> = ({
  eventDateTime,
  eventThumbnailURL,
  eventTitle,
}) => {
  const classes = styles();

  return (
    <section css={classes.root} aria-label={eventTitle}>
      <SPView>
        <AspectRatioImage
          src={eventThumbnailURL}
          alt={eventTitle}
          aspectRatio={16 / 9}
        />
      </SPView>
      <PCView>
        <AspectRatioImage
          src={eventThumbnailURL}
          alt={eventTitle}
          aspectRatio={16 / 9}
        />
      </PCView>
      <div css={classes.eventDetails}>
        <h2 css={classes.eventTitle} {...withNoTranslate()}>
          {eventTitle}
        </h2>
        <p css={classes.eventDateTime}>{eventDateTime}</p>
      </div>
    </section>
  );
};

const styles = () => ({
  root: css`
    display: grid;
    grid-template-columns: 104px minmax(0, 1fr);
    align-items: center;
    gap: 16px;
    @media screen and (min-width: 768px) {
      grid-template-columns: 288px minmax(0, 1fr);
      gap: 32px;
    }
  `,
  eventDetails: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    @media screen and (min-width: 768px) {
      gap: 12px;
    }
  `,
  eventTitle: css`
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.5;
    @media screen and (min-width: 768px) {
      font-size: 18px;
    }
  `,
  eventDateTime: css`
    color: #5c5c5c;
    font-size: 10px;
    line-height: 1.5;
    @media screen and (min-width: 768px) {
      font-size: 16px;
    }
  `,
});
